<script setup>

const resendEmail = async () => {
    // TODO: Implement the logic to resend the verification email
};

</script>

<template>
    <div class="verify-email-container">
        <h2>Verify Your Email</h2>
        <p>Please check your email for a verification link.</p>
        <p>If you didn't receive an email, click the button below to resend it.</p>
        <button @click="resendEmail">Resend Verification Email</button>
    </div>
</template>